import evessioAPI from "@/services/api/evessioAPI";

export default {
  /**
   * Get node and type config from server
   * @param commit
   * @param {String} uuid
   * @return {Promise<void>}
   */
  async getConfig({ commit }, { uuid }) {
    let response = await evessioAPI.getContentNodeConfig(uuid);
    commit("setConfig", response.data);
  },

  async getContext({ state, commit }, { includeChildren = 0 }) {
    let response = await evessioAPI.getContentNodeContext({
      uuid: state.config.uuid,
      includeChildren: includeChildren || 0,
      exclude: null
    });
    commit("setContext", response.data);
  },
  /**
   * Update Digital Event
   * @param state
   * @param dispatch
   * @param includeChildren
   * @return {Promise<void>}
   */
  async updateDigitalEvent({ state, dispatch }, { includeChildren = 0 }) {
    await dispatch("getContext", { includeChildren: includeChildren });
    await dispatch("room/getRooms", state.context.uuid, { root: true });
  }
};
